var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 10.6667,
    fill: "#FF3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 13.9755C12.2521 13.9755 12.4932 13.8714 12.6711 13.6862C12.8489 13.501 12.9488 13.2497 12.9488 12.9878V7.06187C12.9488 6.79993 12.8489 6.54872 12.6711 6.3635C12.4932 6.17828 12.2521 6.07422 12.0006 6.07422C11.7492 6.07422 11.508 6.17828 11.3302 6.3635C11.1524 6.54872 11.0525 6.79993 11.0525 7.06187V12.9878C11.0525 13.2497 11.1524 13.501 11.3302 13.6862C11.508 13.8714 11.7492 13.9755 12.0006 13.9755ZM12.0006 17.9261C12.235 17.9261 12.4642 17.8537 12.6591 17.718C12.854 17.5824 13.0059 17.3895 13.0956 17.164C13.1853 16.9384 13.2088 16.6901 13.163 16.4507C13.1173 16.2112 13.0044 15.9912 12.8387 15.8185C12.6729 15.6459 12.4617 15.5283 12.2318 15.4807C12.0019 15.433 11.7636 15.4575 11.5471 15.5509C11.3305 15.6444 11.1454 15.8026 11.0152 16.0056C10.8849 16.2086 10.8154 16.4473 10.8154 16.6915C10.8154 17.0189 10.9403 17.3329 11.1626 17.5645C11.3848 17.796 11.6863 17.9261 12.0006 17.9261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticIcon);
export default __webpack_public_path__ + "static/media/noticIcon.365ab76f5ff6585829422a9593895d46.svg";
export { ForwardRef as ReactComponent };